import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { useForm } from '../../hooks/useForm.js';
import { CalculatorLayout } from '../../ui-kit/Calculator/CalculatorLayout.js';
import { CalculatorStyle } from '../../ui-kit/Calculator/CalculatorStyle.js';
import { CalculatorValue } from '../../ui-kit/Calculator/CalculatorValue.js';
import { renderFootnote } from '../../ui-kit/Calculator/renderFootnote.js';
import { renderRate } from '../../ui-kit/Calculator/renderRate.js';
import { renderWantedSumInput } from '../../ui-kit/Calculator/renderWantedSumInput.js';
import { renderButtonsSection } from '../../ui-kit/LinkButton/renderButtonsSection.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { getBonusCalculatorParams } from './getBonusCalculatorParams.js';
const DEFAULT_TRAVEL_MIN_SUM = 6000;
const DEFAULT_REST_MIN_SUM = 6000;
export const CalculatorBonus = UniBlock(({ className = '', title, calcSource, buttons, footnote, ...rest }) => {
    const [userInputParams, { field }] = useForm({
        travelExpenseValue: DEFAULT_TRAVEL_MIN_SUM,
        restExpenseValue: DEFAULT_REST_MIN_SUM,
    });
    const { minSumTravel, maxSumTravel, minSumOther, maxSumOther, monthBonus, yearBonus } = getBonusCalculatorParams(userInputParams, calcSource);
    return (_jsx(CalculatorLayout, { className: className, title: title, ...rest, children: _jsxs("section", { className: style(CalculatorStyle.wrapper, className), children: [_jsxs("div", { className: CalculatorStyle.input, children: [renderWantedSumInput({
                            title: 'Сумма покупок в категории путешествия, ₽',
                            min: minSumTravel,
                            max: maxSumTravel,
                            step: 500,
                            isShowItems: false,
                            ...field('travelExpenseValue'),
                        }), renderWantedSumInput({
                            title: 'Сумма покупок в остальных категориях, ₽',
                            min: minSumOther,
                            max: maxSumOther,
                            step: 500,
                            isShowItems: false,
                            ...field('restExpenseValue'),
                        })] }), _jsx("div", { className: "mb-s", children: monthBonus >= 0
                        ? renderRate({
                            title: 'Баллов за месяц',
                            rate: monthBonus,
                            fractionDigits: 0,
                            isUnknownRateShown: false,
                            unit: '',
                            color: 'text-primary-text',
                        })
                        : null }), _jsxs("div", { className: CalculatorStyle.result, children: [yearBonus >= 0 ? (_jsx(CalculatorValue, { title: "\u0411\u0430\u043B\u043B\u043E\u0432 \u0437\u0430 \u0433\u043E\u0434", value: yearBonus, color: "text-primary-text" })) : null, renderButtonsSection(buttons, { isVertical: true }), renderFootnote(footnote)] })] }) }));
});
//# sourceMappingURL=CalculatorBonus.js.map